import {
  DocumentTypes,
  UploadedDocumentInfoDocumentType,
} from '@urbanx/agx.campaigns.client'
import { AxiosProgressEvent, GenericAbortSignal } from 'axios'
import CampaignsService from 'services/campaignsService'

export const getFileLink = async (
  authToken: string,
  filePath: string
): Promise<number | undefined> => {
  try {
    const service = new CampaignsService(authToken)

    const { data: result } = await service.campaignsService.get(
      'GetUploadedFileLink',
      { filePath }
    )

    return result
  } catch (err) {
    console.log('err', err)
  }
}

export const uploadFile = async (
  authToken: string,
  file: string | FormData,
  campaignId: string,
  uploadedFormType: DocumentTypes,
  onUploadProgressChanged:
    | ((progressEvent: AxiosProgressEvent) => void)
    | null = null,
  abortSignal: GenericAbortSignal | null = null,
  filePath?: string,
  contractId?: string
): Promise<any> => {
  try {
    const service = new CampaignsService(authToken)

    const { data: result } = await service.campaignsService.post(
      'AddOrUpdateDocument',
      file,
      {
        CampaignId: campaignId,
        ContractId: contractId,
        onUploadProgress: onUploadProgressChanged,
        documentType: uploadedFormType,
        signal: abortSignal,
        ...(filePath && { filePath }),
      }
    )
    return result
  } catch (err) {
    console.log('err', err)
  }
}

export const editFile = async (
  authToken: string,
  file: FormData,
  campaignId: string,
  uploadedFormType: UploadedDocumentInfoDocumentType,
  filePath: string,
  onUploadProgressChanged:
    | ((progressEvent: AxiosProgressEvent) => void)
    | null = null,
  abortSignal: GenericAbortSignal | null = null
): Promise<any> => {
  try {
    const service = new CampaignsService(authToken)

    const { data: result } = await service.campaignsService.post(
      'AddOrUpdateDocument',
      file,
      {
        CampaignId: campaignId,
        documentType: uploadedFormType,
        onUploadProgress: onUploadProgressChanged,
        filePath: filePath,
        signal: abortSignal,
      }
    )
    return result
  } catch (err) {
    console.log('err', err)
  }
}

export const deleteFile = async (
  authToken: string,
  filePath: string
): Promise<number | undefined> => {
  try {
    const service = new CampaignsService(authToken)

    const { status } = await service.campaignsService.post('RemoveFile', {
      filePath,
    })
    return status
  } catch (err) {
    console.log('err', err)
  }
}
